import React from "react";

const ContactAreaThree = () => {
  return (
    <>
      {/* ========================= contact Area Three start =========================*/}
      <div className='price-process-area pd-top-120'>
        <div className='contact-inner-1 contact-inner-2'>
          <div className='row'>
            <div
              className='col-lg-6 '
              data-aos='fade-right'
              data-aos-delay='200'
              data-aos-duration='1500'
            >
              <img className='w-100' src='assets/img/about/12.png' alt='img' />
            </div>
            <div
              className='col-lg-4'
              data-aos='fade-left'
              data-aos-delay='100'
              data-aos-duration='1500'
            >
              <div className='section-title mb-0'>
                <h6 className='sub-title'>GET IN TOUCH</h6>
                <h2 className='title mb-4'>
                  Smart Solutions For <span>Smart</span> Founders
                </h2>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Strategic Funding Guidance</h5>
                    <p className='mb-0'>
                      Get clarity on your funding path with expert advisory services tailored to your startup's stage and goals.
                    </p>
                  </div>
                </div>
                <div className='media mb-3'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Accelerated Execution</h5>
                    <p className='mb-0'>
                      Transform your startup vision into reality with our structured accelerator program and development services.
                    </p>
                  </div>
                </div>
                <div className='media'>
                  <div className='media-left me-3'>
                    <img src='assets/img/icon/26.svg' alt='img' />
                  </div>
                  <div className='media-body'>
                    <h5>Investor-Ready Positioning</h5>
                    <p className='mb-0'>
                      Build a fundable business with proper market positioning, validated assumptions, and scalable foundations.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*========================= contact-inner Three end =========================*/}
    </>
  );
};

export default ContactAreaThree;
